import { Component, OnInit } from '@angular/core';
import { ProgressSpinnerMode, ThemePalette } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-daily-sale-cash-credit-statement',
  templateUrl: './daily-sale-cash-credit-statement.component.html',
  styleUrls: ['./daily-sale-cash-credit-statement.component.scss']
})
export class DailySaleCashCreditStatementComponent implements OnInit {

  from_date: any = new Date().toISOString().split('T')[0];
  to_date: any = new Date().toISOString().split('T')[0];
  is_document_available: boolean = true;
  is_data_available: boolean = true;
  document_details: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  total_sale_details: any;
  test_data: any;
  title = null;
  pdf_data: any;
  is_excel_available: boolean = true;
  excel_details: any = null;

  constructor(private httpService: HttpService, private dom: DomSanitizer, private global: GlobalService) {
    this.title = this.global._active_display_name;
  }

  getClicked() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date
    };
    this.is_document_available = false;
    this.httpService.serveDailyCashAndCreditStatement(data_dict).subscribe((data) => {
      this.pdf_data = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['pdf']);
      this.document_details = data;
      console.log(this.document_details);
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
    
    this.httpService.serveDailyCashAndCreditStatementExcel(data_dict).subscribe((data) => {
      //this.pdf_data = this.dom.bypassSecurityTrustResourceUrl('data:application/xlsx;base64,' + data['xlsx']);
      this.excel_details = data;
      console.log(this.excel_details);
      this.is_excel_available = true;
    }, (error) => {
      this.is_excel_available = true;
    });

  }

  downloadReportCliked() {
    console.log('clicked');
    const linkSource = 'data:application/pdf;base64,' + this.document_details['pdf'];
    // this.test_data = this.dom.bypassSecurityTrustResourceUrl(linkSource);
    const downloadLink = document.createElement("a");
    const fileName = this.document_details['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    console.log(fileName);
    downloadLink.click();
  }

  downloadExcelCliked() {
    const linkSource = 'data:application/xlsx;base64,' + this.excel_details['excel'];
    // this.test_data = this.dom.bypassSecurityTrustResourceUrl(linkSource);
    const downloadLink = document.createElement("a");
    const fileName = this.excel_details['excel_file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }


  getPdf() {
    return this.dom.bypassSecurityTrustResourceUrl(this.pdf_data);
  }

  ngOnInit() {
  }

}
